import { createTheme } from '@mui/material/styles';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#0cb5f7',
      light: '#4fc9fa',
      dark: '#0a9dd8',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#9857c7',
      light: '#b078d6',
      dark: '#7938a8',
      contrastText: '#ffffff',
    },
    success: {
      main: '#48BB78',
      light: '#68D391',
      dark: '#38A169',
      contrastText: '#ffffff',
    },
    background: {
      default: '#1a202c',
      paper: '#2d3748',
    },
    text: {
      primary: '#f7fafc',
      secondary: '#a0aec0',
    },
    divider: 'rgba(255, 255, 255, 0.12)',
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
  },
  shape: {
    borderRadius: 12,
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 768,
      md: 992,
      lg: 1024,
      xl: 1200,
      xxl: 1440,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '*::-webkit-scrollbar': {
          width: '8px',
          height: '8px',
        },
        '*::-webkit-scrollbar-track': {
          background: '#2d3748',
          borderRadius: '4px',
        },
        '*::-webkit-scrollbar-thumb': {
          background: '#4a5568',
          borderRadius: '4px',
        },
        '*::-webkit-scrollbar-thumb:hover': {
          background: '#718096',
        },
      },
    },
  },
});

export default darkTheme;
